// extracted by mini-css-extract-plugin
module.exports = {"assessment-patient-card":"style_assessment-patient-card__kUz4f"};